import { createContext, useState } from 'react';

import useMemoObject from '@zenbusiness/application-commons-hooks/useMemoObject';

export const ChangeRequest = createContext({
  changeFlow: {}
});

export const SetChangeRequest = createContext({
  setChangeFlow: () => {}
});

export const baseModalContext = {
  orderBillingItemUuid: null,
  interval: null,
  changeType: null,
  changeDescription: '',
  changeReason: null,
  modalFlow: {
    error: false,
    restartSubscription: {
      start: false,
      stepOne: false,
      stepTwo: false
    },
    changeBillingIntervalAnnual: {
      start: false,
      stepOne: false,
      stepTwo: false,
      stepThree: false
    }
  }
};

export default function ChangeRequestContext({ children }) {
  const [changeFlow, setChangeFlow] = useState(baseModalContext);

  const contextOne = useMemoObject({ changeFlow });
  const contextTwo = useMemoObject({ setChangeFlow });

  return (
    <ChangeRequest.Provider value={contextOne}>
      <SetChangeRequest.Provider value={contextTwo}>
        {children}
      </SetChangeRequest.Provider>
    </ChangeRequest.Provider>
  );
}
